import { useEffect, useState } from 'react';
import { Button, FormControl, FormControlLabel, FormHelperText, OutlinedInput, Radio } from '@mui/material'
import style from './index.module.scss'
import FeedbackStar from '../feedback_star'
import { useTranslation } from '@/i18n/client';
import UKToast from '@/components/UKToast'

import { fetchFeedbackGetList, fetchFeedbackSubmit } from '@/apis/feedback/feedback.api'
import type { SubjectInfoDTOList } from '@/apis/feedback/feedback.interface'
import {
	RadioLabelStyle,
	RadioColorStyle,
	DescTitleStyle,
	SubmitBTnStyle
} from './style'
import SuccessIcon from '@/assets/icons/SuccessIcon.svg'

interface PropsType {
	sourceType: number //反馈来源类型 枚举值 1-Me、2-Search、3-Recommend、4-Products
}

export const FeedbackCard = ({ sourceType }: PropsType) => {
	const { t } = useTranslation();

	const [isShow, setIsShow] = useState(false)
	const [scoreNum, setScoreNum] = useState(0)
	const [subjectList, setSubjectList] = useState<SubjectInfoDTOList[]>([])
	const [selectedValue, setSelectedValue] = useState<string>(); // 默认选中
	const [selectedSubject, setSelectedSubject] = useState<string>(); // 默认选中
	const [subjectRadio, setSubjectRadio] = useState();// 需要反馈的问题类型
	const [isSubmitting, setIsSubmitting] = useState(false); // 正在提交中
	const [isSuccess, setIsSuccess] = useState(false);
	const getFeedbackList = async () => {
		const res = await fetchFeedbackGetList({ sourceType })
		const { code, data } = res
		if (code === '200') {
			setSubjectList(data?.subjectInfoDTOList || [])
			setIsShow(true);
		} else {
			setIsShow(false);
		}
	}
	const handleChange = (event: any, item: SubjectInfoDTOList) => {
		setSelectedSubject(item.subject)
		setSelectedValue(event.target.value);
		setSubjectRadio(event.target.value);
	}
	//只上报评分
	const onStarSubmit = async () => {
		const params = {
			sourceType,
			starScore: scoreNum,
			platform: 3,
		}
		fetchFeedbackSubmit(params)
	}

	const closeStarHandler = () => {
		if (scoreNum) {
			onStarSubmit()
		}
		handlerClose()
	}

	const handlerClose = () => {
		setIsShow(false);
	}

	//点击star事件
	const clickStar = (scoreNum: number) => {
		setScoreNum(scoreNum)
	}
	// 提交反馈
	const OnSubmit = async () => {
		if (isSubmitting) {
			return
		}

		let params = {
			sourceType,
			subjectType: subjectRadio,
			platform: 3,
			appVersion: "",
			starScore: scoreNum,
		}

		setIsSubmitting(true);
		fetchFeedbackSubmit(params).then((res) => {
			if (res && res.success) {
				setIsSuccess(true)
			} else {
				setIsSubmitting(false);
				UKToast.show({
					icon: 'fail',
					content: t('common.message.tryAgain'),
				})
			}
		});
	};
	useEffect(() => {
		if (isSuccess) {
			//延迟3秒后关闭
			setTimeout(() => {
				handlerClose()
			}, 3000)
		}
	}, [isSuccess])

	useEffect(() => {
		getFeedbackList()
	}, [])

	if (!isShow) {
		return null
	}

	return (
		<div className={style.feedbackCard}>
			{
				isSuccess ?
					<div className={style.success}>
						<SuccessIcon width={26} height={26} />
						<span className={style.successText}>{t('feedback.ThanksForYourFeedback')}</span>
					</div> :
					<>
						<FeedbackStar
							onClose={closeStarHandler}
							onClickStar={clickStar}
							sourceType={3}
							title={t('feedback.HowAboutTheResults')}
							starWidth={32}
						/>
						<div className={style.form}>
							{/* <div className={style.form_title}>{`Please let us know what you think about our ${sourceType === 3 ? 'recommendations' : 'search results.'}.`}</div> */}
							<div className={style.form_title}>{t('feedback.PleaseLetUsKnowWhatYouThinkAboutOur', { pageText: sourceType === 3 ? t('feedback.recommendations') : t('feedback.searchResults') })}</div>
							{
								subjectList && subjectList.length > 0 &&
								<div className={style.form__radio}>
									{
										subjectList.map((item: SubjectInfoDTOList, index: number) => {
											return (
												<div key={index}>
													<FormControlLabel
														sx={RadioLabelStyle}
														value={String(item.subjectType)}
														label={item.subject}
														control={
															<Radio
																sx={RadioColorStyle}
																checked={selectedValue === String(item.subjectType)}
																onChange={(e) => handleChange(e, item)}
																value={String(item.subjectType)}
																name="radio-buttons"
															/>
														}
													/>
												</div>
											)
										})
									}
								</div>
							}
						</div>
						<Button
							sx={SubmitBTnStyle}
							onClick={OnSubmit}
							disableElevation
							disabled={selectedValue == "0" || !scoreNum}>
							{t('common.btnText.submit')}
						</Button>
					</>
			}

		</div>
	)
}